import { Fragment, useEffect, useState } from "react";
import "./css/campañas.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { Controller, useForm } from "react-hook-form";
import { verificarCedula } from "udv-ec";
import InputMask from "react-input-mask";
import AOS from "aos";
import cuid from "cuid";
import Swal from "sweetalert2";
import Form from "react-bootstrap/Form";
import Spinner from "../spinner/Spinner";
import Table from "react-bootstrap/Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { Server } from "../../constants";
import axios from "axios";
import { FiSearch } from "react-icons/fi";
import { IoSaveOutline } from "react-icons/io5";
import { servicioGuardarInteresadoCampania } from "../../services/serviciosRepuestos";

function InfoCampaniaNuevo() {
    const { register, control, handleSubmit, setValue, formState: { errors } } = useForm({
        defaultValues: {
            identificacion: "",
            nombre: "",
            apellido: "",
            telefono: "",
            celular: "",
            correo: "",
            selectCiudad: "",
            selectConcesionario: "",
            descripcionRepuesto: "",
            chasis: "",
        }
    });
    const [campanias, setCampanias] = useState([]);
    const [vin, setVin] = useState("");
    const [activeSpinner, setActiveSpinner] = useState(false);
    const [controlTable, setControlTable] = useState(false);

    useEffect(() => {
        AOS.init({
            duration: 1000,
        });
    }, []);

    const onSubmit = async (formData) => {
        const dataForm = new FormData();
        let cid = cuid();
        dataForm.append("id", cid);
        dataForm.append('nombre', formData.nombre);
        dataForm.append('apellido', formData.apellido)
        dataForm.append('identificacion', formData.identificacion)
        dataForm.append('celular', formData.celular)
        dataForm.append('email', formData.correo)
        dataForm.append('chasis', formData.chasis)
        const respuestaServicio = await servicioGuardarInteresadoCampania(dataForm);
        if (respuestaServicio?.status) {
            limpiarFormulario();
            Swal.fire({
                title: "ÉXITO",
                text: "Su solicitud fue enviada, pronto un asesor Hyundai te contactará.",
                showCloseButton: true,
                icon: "success",
            });
        } else {
            Swal.fire({
                title: "Información",
                text: "No se pudo generar la solicitud, por favor intente en unos minutos.",
                showCloseButton: true,
                icon: "info",
            });
        }
    }

    const limpiarFormulario = () => {
        setValue('identificacion', "");
        setValue('nombre', "");
        setValue('apellido', "");
        setValue('telefono', "");
        setValue('celular', "");
        setValue('correo', "");
        setValue('selectCiudad', "");
        setValue('selectConcesionario', "");
        setValue('descripcionRepuesto', "");
    }

    const handleSubmitFormChasis = async (event) => {
        event.preventDefault();
        setActiveSpinner(true);
        const url = `${Server}/api/obtener_vin/${vin}`;
        const resultado = await axios.get(url);
        if (resultado.status === 200 && resultado.data.length === 0) {
            setActiveSpinner(false);
            setCampanias(resultado.data);
            setControlTable(true);
        } else {
            let today = new Date();
            let date = (
                today.getFullYear() +
                "-" +
                (today.getMonth() + 1) +
                "-" +
                today.getDate()
            ).replace(/(^|\D)(\d)(?!\d)/g, "$10$2");
            let camp = [];
            for (let i = 0; i < resultado.data.length; i++) {
                if (resultado.data[i].POS_VIGENCIA > date) {
                    camp.push(resultado.data[i]);
                }
            }
            setCampanias(camp);
            setActiveSpinner(false);
            setControlTable(true);
        }
    }

    return (
        <Fragment>
            <div className='fondo-campanias centrar-global'>
                <section className='textos-header-campañas centrar-global pl-5 pr-5'>
                    <div>
                        <h1 data-aos="fade-right"
                            className="text-center"
                        >Campañas Hyundai</h1>
                        <p className="descripcion-campania text-center">
                            Para Hyundai la calidad y seguridad preventiva es prioridad, es por ello que introduciendo
                            tu número de chasis podrás conocer si tu Hyundai forma parte de cualquier campaña activa.
                        </p>
                    </div>
                </section>
            </div>
            <Container className="mb-5 pb-0">
                <Row className="centrar-global">
                    <Col xs={12} md={12}>
                        <Card className="card-chasis mt-5">
                            <Card.Body className="card-chasis">
                                <h3>¿Dónde puedo ver mi número de chasis?</h3>
                                <p>
                                    El número de chasis o VIN es único para cada vehículo, el mismo
                                    está compuesto por 17 dígitos el cual puedes verificar en tu
                                    documento de matrícula o en la parte inferior del parabrisas
                                    delantero de tu vehículo.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} md={6} className="centrar-global mt-5">
                        <Form
                            className="form-campania"
                            onSubmit={handleSubmitFormChasis}
                            id="formCampania"
                        >
                            <Form.Group className="w-100 ">
                                <h3>Ingresa tu número de Chasis</h3>
                                <Form.Control
                                    type="text"
                                    placeholder="Número de Chasis"
                                    required
                                    value={vin}
                                    onChange={(e) => {
                                        setVin(e.target.value);
                                        setValue('chasis', e.target.value);
                                    }}
                                />
                            </Form.Group>
                            {activeSpinner ? (
                                <Spinner />
                            ) : (
                                <Form.Group>
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="text-decoration-none btn-campania"
                                    >
                                        Consultar <FiSearch className="ml-3"></FiSearch>
                                    </Button>
                                </Form.Group>
                            )}
                        </Form>
                    </Col>
                </Row>
                <Container className="mb-4 mt-4">
                    {controlTable === true ? (
                        campanias.length === 0 ? (
                            <Row>
                                <Col md={12}>
                                    <p className="campania-mensaje mt-2">
                                        Su vehículo no tiene campañas asociadas.
                                    </p>
                                </Col>
                            </Row>
                        ) : (
                            <>
                                <Row className="mb-4 mt-4">
                                    <Col md={12}>
                                        <h2 className="campania-asociada-title">Campañas asociadas a tu Hyundai.</h2>
                                    </Col>
                                </Row>
                                <Table responsive bordered className="tabla-campania">
                                    <thead>
                                        <tr>
                                            <td>Información Campaña</td>
                                            <td>Modelo</td>
                                            <td>Vigencia</td>
                                            <td>Agenda tu Cita</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {campanias.map((campania, index) => (
                                            <tr key={index}>
                                                <td>{campania.POS_DESCRIPCION}</td>
                                                <td>{campania.POS_MODELO}</td>
                                                <td>{campania.POS_VIGENCIA}</td>
                                                <td className="text-center my-auto">
                                                    <button className="btn-agendar"
                                                        onClick={() => {
                                                            var elemento = document.getElementById("identificacion");
                                                            elemento.focus();
                                                        }}
                                                    >
                                                        <FontAwesomeIcon icon={faClock} /> Agendar
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </>
                        )
                    ) :
                        null
                    }
                </Container>
            </Container>
            <section className="mt-5 bg-gray-color-v2" id="section-form-cotizador">
                <Container className="pt-5 pb-5">
                    <Row className=" pb-5">
                        <Col className="card-formulario">
                            <h3>¿Qué hago si mi Hyundai forma parte de alguna campaña?</h3>
                            <p className="h-head-r h18 centrar-global mt-4">
                                Puedes completar el siguiente formulario para agendar una cita en cualquier
                                taller autorizado
                                a nivel nacional sin costo alguno:
                            </p>
                            <Card className="w-100 mt-5">
                                <form onSubmit={handleSubmit(onSubmit)} id="form-cotizador">
                                    <Card.Header >
                                        <h4 >Agenda tu cita</h4>
                                    </Card.Header>
                                    <Card.Body>
                                        <Row >
                                            <Col>
                                                <div className="input-repuestos">
                                                    <label htmlFor="identificacion">Identificación:</label>
                                                    <Controller
                                                        rules={{
                                                            required: 'Identificación requerida',
                                                            validate: (value) =>
                                                                verificarCedula(value) || "Cédula incorrecta"
                                                        }}
                                                        name="identificacion"
                                                        control={control}
                                                        render={({ field: { onChange, value } }) =>
                                                            <InputMask
                                                                mask="9999999999"
                                                                maskChar=" "
                                                                name="identificacion"
                                                                value={value}
                                                                onChange={onChange}
                                                            >
                                                                {(inputProps) => (
                                                                    <input
                                                                        {...inputProps}
                                                                        placeholder="Identificación"
                                                                        id="identificacion"
                                                                    />
                                                                )}
                                                            </InputMask>}
                                                    />
                                                    {errors.identificacion ?
                                                        <span className="message-error-repuestos">
                                                            {errors.identificacion.message}
                                                        </span>
                                                        :
                                                        <span className="no-error">""</span>
                                                    }
                                                </div>
                                                <div className="input-repuestos">
                                                    <label htmlFor="nombre">Nombres:</label>
                                                    <input
                                                        id="nombre"
                                                        type="text"
                                                        placeholder="Nombres"
                                                        {
                                                        ...register("nombre",
                                                            {
                                                                required: "Nombre requerido",
                                                                maxLength: 100
                                                            }
                                                        )
                                                        }
                                                    />
                                                    {errors.nombre ?
                                                        <span className="message-error-repuestos">
                                                            {errors.nombre.message}
                                                        </span>
                                                        :
                                                        <span className="no-error">""</span>
                                                    }
                                                </div>
                                                <div className="input-repuestos">
                                                    <label htmlFor="apellido">Apellidos:</label>
                                                    <input type="text"
                                                        placeholder="Apellidos"
                                                        id="apellido"
                                                        {
                                                        ...register("apellido",
                                                            {
                                                                required: "Apellido requerido",
                                                                maxLength: 100
                                                            }
                                                        )
                                                        }
                                                    />
                                                    {errors.apellido ?
                                                        <span className="message-error-repuestos">
                                                            {errors.apellido.message}
                                                        </span>
                                                        :
                                                        <span className="no-error">""</span>
                                                    }
                                                </div>
                                            </Col>
                                            <Col>
                                                <div className="input-repuestos">
                                                    <label htmlFor="celular">Celular:</label>
                                                    <Controller
                                                        rules={{ required: 'Número requerido' }}
                                                        name="celular"
                                                        control={control}
                                                        render={({ field: { onChange, value } }) =>
                                                            <InputMask
                                                                id="celular"
                                                                type="text"
                                                                mask="09 9999 9999"
                                                                maskChar=" "
                                                                value={value}
                                                                onChange={onChange}
                                                            >
                                                                {(inputProps) => (
                                                                    <input
                                                                        {...inputProps}
                                                                        placeholder="09 8765 4321"
                                                                    />
                                                                )}
                                                            </InputMask>
                                                        }
                                                    />
                                                    {errors.celular ?
                                                        <span className="message-error-repuestos">
                                                            {errors.celular.message}
                                                        </span>
                                                        :
                                                        <span className="no-error">""</span>
                                                    }
                                                </div>
                                                <div className="input-repuestos">
                                                    <label htmlFor="correo">Correo electrónico:</label>
                                                    <input type="text"
                                                        placeholder="usuario@correo.com"
                                                        id="correo"
                                                        {
                                                        ...register("correo",
                                                            {
                                                                required: "Correo electrónico requerido",
                                                                maxLength: 50,
                                                                pattern: {
                                                                    value: /^(([^<>()\]\\.,;:\s@”]+(\.[^<>()\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z]{2,}))$/,
                                                                    message: "Dirrección de correo no válido"
                                                                }
                                                            }
                                                        )
                                                        }
                                                    />
                                                    {errors.correo ?
                                                        <span className="message-error-repuestos">
                                                            {errors.correo.message}
                                                        </span>
                                                        :
                                                        <span className="no-error">""</span>
                                                    }
                                                </div>
                                                <div className="input-repuestos">
                                                    <label htmlFor="chasis">Chasis:</label>
                                                    <input type="text"
                                                        placeholder="____ _____ _____"
                                                        id="chasis"
                                                        maxLength={17}
                                                        {
                                                        ...register("chasis",
                                                            {
                                                                required: "Chasis requerido",
                                                                maxLength: 17
                                                            }
                                                        )
                                                        }
                                                    />
                                                    {errors.chasis ?
                                                        <span className="message-error-repuestos">
                                                            {errors.chasis.message}</span>
                                                        :
                                                        <span className="no-error">""</span>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <p className="mt-2 pl-md-4 titulo-legal">
                                                Términos y condiciones
                                            </p>
                                            <p className=" pr-md-3 pl-md-4 texto-legal">
                                                Al enviarnos tu información, autorizas de manera expresa al tratamiento y
                                                conservación de tus datos personales, según lo estipulado en la Política de
                                                Protección de Datos Personales de HYUNDAI ECUADOR
                                            </p>
                                        </Row>
                                    </Card.Body>
                                    <Card.Footer style={{ marginTop: '50px' }} className="footer-repuestos">
                                        <button className="btn-repuestos">
                                            Guardar <IoSaveOutline className="ml-3" />
                                        </button>
                                    </Card.Footer>
                                </form>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Fragment>
    );
}
export default InfoCampaniaNuevo;